import { Methods, QueryWrapper } from '@newview/infrastructure';
import { DbCenterBaseApiV2 } from "../../DbCenterBaseApiV2";

export class CalcOptionApi extends DbCenterBaseApiV2 {

    public get ControllerName(): any {
        return 'calcOption';
    }

    /**
     * 获取Python代码模板
     * @returns 
     */
    public getPythonTemplete() {
        const query = QueryWrapper.create().eq("OptionCatalog", "CodeTemplate").eq("OptionKey", "Python");
        return this.getEntityByFilter(query);
    }
}